










































import { Prop, Vue } from 'vue-property-decorator';
import Component from 'vue-class-component';
import ResponsiveIcon from '@/core/responsive/image/ResponsiveIcon.vue';
import { CategoryTileBlockImageModes } from '@/project/app/blocks/categories/CategoryTileBlock.vue';
import { IResponsiveImageWidthOnScreenConfig } from '@/core/responsive/image/ResponsiveImage.vue';
import { CategoryTileViewModel } from '@/types/contentServerContract';

@Component({
    components: { ResponsiveIcon }
})
export default class CategoryTileBlockItem extends Vue {
    @Prop({
        type: Object
    }) content!: CategoryTileViewModel | null;

    @Prop()
    imageMode!: CategoryTileBlockImageModes;

    @Prop()
    clippedImageDimensions!: undefined | { width: number, height: number };

    @Prop()
    imageSizesAttributes!:IResponsiveImageWidthOnScreenConfig | number;

    get buttonClass(): string {
        return this.content?.buttonFullWidth ? 'w-full' : '';
    }

    get computedImageClippedDimensions(): { width: number, height: number} {
        if (this.imageMode === CategoryTileBlockImageModes.clipped) {
            // const width = this.content.image?.height
            return { width: 346, height: 232 };
        }
        return { width: 0, height: 0 };
    }

    get imageAspectRatio() {
        if (this.imageMode === CategoryTileBlockImageModes.clipped) return undefined;
        if (this.imageMode === CategoryTileBlockImageModes.lowFull) return 210 / 136;

        return 268 / 208; // High aspect ratio
    }

    get imageAlt(): string {
        return this.content?.headline || this.content?.description || this.content?.callToAction?.name || '';
    }

    get CategoryTileBlockImageModes() {
        return CategoryTileBlockImageModes;
    }
}
